import { render, staticRenderFns } from "./ExternalVideo.vue?vue&type=template&id=e710bb0e&"
import script from "./ExternalVideo.vue?vue&type=script&lang=js&"
export * from "./ExternalVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports